import { isAuthenticated, isNotAuthenticated } from '@/common/utils/routerMixins';


import RegisterResearchStart from '@/common/views/RegisterResearchStart.vue';
import ArticleList from './views/ArticleList.vue';
import ArticleDetail from './views/ArticleDetail.vue';
import CommercialCreateStartChristmas from './views/CommercialCreateStartChristmas.vue';
import CommercialCreateStartEK2024 from './views/CommercialCreateStartEK2024.vue';
import RegisterCommercialCompetition from './views/RegisterCommercialCompetition.vue';
import AuthRedirect from './views/AuthRedirect.vue';
import EmailChangeConfirm from './views/EmailChangeConfirm.vue';
import Register from './views/Register.vue';
import ResetPassword from './views/ResetPassword.vue';
import Success from './views/Success.vue';
import UserProfile from './views/UserProfile.vue';

export default [
  {
    path: '/auth-redirect/',
    name: 'auth-redirect',
    component: AuthRedirect,
    meta: {
      hideNavigation: true,
    },
  },
  {
    path: '/success/',
    name: 'success',
    component: Success,
    meta: {
      bgClass: 'bg-default-dark',
      hideNavigation: true,
      hideFooter: true,
      noPadding: true,
    },
  },
  {
    // Generic view to register as a user (with or without organisation);
    path: '/register/:as',
    name: 'register-as',
    component: Register,
    beforeEnter: isNotAuthenticated,
    meta: {
      bgClass: 'bg-default-dark',
      hideFooter: true,
      noPadding: true,
    },
  },
  {
    // Generic view to register as a user (with or without organisation);
    path: '/register/',
    name: 'register',
    component: Register,
    beforeEnter: isNotAuthenticated,
    meta: {
      bgClass: 'bg-default-dark',
      hideFooter: true,
      noPadding: true,
    },
  },
  {
    path: '/profile/',
    name: 'user-profile',
    beforeEnter: isAuthenticated,
    component: UserProfile,
    meta: {
      showBreadcrumbs: true,
    },
  },
  {
    path: '/email-change/:uuid/confirm/',
    name: 'email-change',
    beforeEnter: isAuthenticated,
    component: EmailChangeConfirm,
    meta: {
      bgClass: 'bg-default-dark',
      hideNavigation: true,
      hideFooter: true,
    },
  },
  {
    path: '/reset-password/:uuid/',
    name: 'reset-password',
    component: ResetPassword,
    beforeEnter: isNotAuthenticated,
    meta: {
      bgClass: 'bg-default-dark',
    },
  },

  // Public (phase out pages);
  {
    path: '/articles/',
    name: 'article-list',
    component: ArticleList,
    meta: {
      showBreadcrumbs: true,
    },
  },
  {
    path: '/articles/:slug/',
    name: 'article-detail',
    component: ArticleDetail,
    meta: {
      showBreadcrumbs: true,
      shareEnabled: true,
    },
  },
  {
    path: '/aanmelden/',
    name: 'public-register-commercial',
    component: RegisterResearchStart,
    meta: {
      shareEnabled: true,
      organisationPage: true,
    },
  },
  {
    path: '/aanmelden/:commercialType',
    name: 'public-register-commercial-type',
    component: RegisterResearchStart,
    meta: {
      shareEnabled: true,
    },
  },
  {
    path: '/commercialcompetitie/',
    name: 'public-register-commercial-competition',
    component: RegisterCommercialCompetition,
    meta: {
      shareEnabled: true,
      hideFooter: true,
      bgClass: 'bg-default-dark',
      hideNavigation: true,
    },
  },
  {
    path: '/test-aanvragen/',
    redirect: '/organisation/request-research',
  },
  {
    path: '/decembercommercials/',
    name: 'register-commercial-december',
    component: CommercialCreateStartChristmas,
    meta: {
      hideNavigation: true,
      bgClass: 'bg-christmas',
      noPadding: true,
      hideFooter: true,
      shareEnabled: true,
      shareUrl: '/decembercommercials/',
    },
  },
  {
    path: '/ek2024/',
    name: 'register-commercial-ek2024',
    component: CommercialCreateStartEK2024,
    meta: {
      hideNavigation: true,
      bgClass: 'bg-ek2024',
      noPadding: true,
      hideFooter: true,
      shareEnabled: true,
      shareUrl: '/decembercommercials/',
    },
  },
  {
    path: '/competitie/',
    redirect: '/commercialcompetitie/',
  },
  {
    path: '/voor-bedrijven/',
    redirect: '/',
  },
];
